export const ProgressSteps = {
    NOT_ACTIVE: 0,
    FINDING: 1,
    ENROUTE: 2,
    AT_SCENE: 3,
    IN_CANCEL: 4
}